import React from "react";
import { Card, CardContent, Fade, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  card: {
    width: "100%",
    maxWidth: 500,
  },
  content: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

const InviteMessage = ({ title, message }) => {
  const classes = useStyles();

  return (
    <Fade in>
      <div className={classes.container}>
        <Card className={classes.card} raised>
          <CardContent className={classes.content}>
            <Typography variant="h6" color="primary" className={classes.title}>
              {title}
            </Typography>

            <Typography variant="body1" color="textSecondary">
              {message}
            </Typography>
          </CardContent>
        </Card>
      </div>
    </Fade>
  );
};

export default InviteMessage;
